module.exports = __webpack_public_path__ + "images/hoppenbrouwers_small3f39947efaeb39a54db42b319e35a826.png";